import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RoleAccessService } from '../../shared/services/role-access.service';
import { RoutePath } from '../../shared/enums/common.enum';

/**
 * Allows only sub-admins to access a route.
 * Non-sub-admins get redirected to the admin landing module.
 */
export const subAdminOnlyGuard: CanActivateFn = () => {
  const router = inject(Router);
  const roleAccessService = inject(RoleAccessService);

  if (roleAccessService.isSubAdmin()) {
    return true;
  }

  return router.createUrlTree([`/${RoutePath.SUB_ADMIN}`]);
};
